// BuyerAccountPage.jsx
import React, { useState, useEffect, useContext } from "react";
import { Container, Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  FaUser,
  FaBox,
  FaHeart,
  FaHeadset,
  FaCog,
  FaChevronRight,
  FaEdit,
  FaArrowLeft,
} from "react-icons/fa";
import "../../../assets/css/customer/screens/MyAccount.css";
import BottomNavigation from "../../../components/general/bottomnavigation/BottomNavigation";
import MyNavbar from "../../../components/general/mynavbar/MyNavbar";
import Footer from "../../../components/general/footer/Footer";
import AppContext from "../../../contexts/AppContext";
import LoadingScreen from "../../../components/general/animations/Animations.js";

const AccountPage = () => {
  const navigate = useNavigate();
const { customer, baseUrlForFiles, logout, baseUrl, customerAuthToken } =
  useContext(AppContext);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2500);
    return () => clearTimeout(timer);
  }, []);



const fetchUserData = async () => {
  try {
    const customer_id = localStorage.getItem("customer_id");
    if (!customer_id) return;

    const formData = new FormData();
    formData.append("customer_id", customer_id);

    const response = await axios.post(
      `${baseUrl}/customer/viewProfile`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${customerAuthToken}`,
        },
      },
    );
  } catch (error) {
    console.error("Error fetching customer data:", error);
  }
};
  const accountOptions = [
    {
      icon: FaBox,
      title: "My Orders",
      description: "Track, return, or buy things again",
      path: "/orders",
      color: "#FF8559",
    },
    {
      icon: FaHeart,
      title: "Wishlist",
      description: "Your saved items",
      path: "/favorites",
      color: "#FF8559",
    },
    {
      icon: FaHeadset,
      title: "Support & Help",
      description: "Contact support or view FAQs",
      path: "/support",
      color: "#FF8559",
    },
    {
      icon: FaCog,
      title: "Settings",
      description: "Manage your account settings",
      path: "/settings",
      color: "#FF8559",
    },
  ];

  useEffect(() => {
     fetchUserData();
  }, []);

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <>
    <MyNavbar />
      <div className="account-buyer-account-page">
        
        <Container>
          {/* Outer Shell Container */}
          <div className="account-account-shell-container" >
            {/* Back Arrow */}
            <button className="account-back-button" onClick={() => navigate("/")}>
              <FaArrowLeft size={20} />
            </button>

            {/* My Account Heading */}
            <h2 className="account-page-title">My Account</h2>

            {/* Profile Header */}
            <Card className="account-profile-header-card">
              <div className="account-profile-content">
                <div className="account-profile-image-section">
                  {customer?.profile_image ? (
                    <img
                      src={`${baseUrlForFiles}/${customer.profile_image}`}
                      alt="Profile"
                      className="account-profile-image"
                    />
                  ) : (
                    <div className="account-profile-image account-profile-placeholder">
                      <FaUser size={40} />
                    </div>
                  )}
                  <div
                    className="account-edit-avatar-icon"
                    onClick={() => navigate("/edit-profile")}
                  >
                    <FaEdit size={14} />
                  </div>
                </div>
                <div className="account-profile-details">
                  <h2>
                    {customer?.first_name} {customer?.last_name}
                  </h2>
                  <p className="account-customer-email">{customer?.email}</p>
                  <p className="account-customer-phone">{customer?.phone}</p>
                </div>
              </div>
            </Card>

            {/* Account Options */}
            <div className="account-account-section">
              <h3 className="account-account-section-title">Account Options</h3>
              <div className="account-options-list">
                {accountOptions.map((option, index) => (
                  <Card
                    key={index}
                    className="account-account-option-card"
                    onClick={() => navigate(option.path)}
                  >
                    <div className="account-option-content">
                      <div
                        className="account-option-icon"
                        style={{ backgroundColor: `${option.color}15` }}
                      >
                        <option.icon
                          size={24}
                          style={{ color: option.color }}
                        />
                      </div>
                      <div className="account-option-text">
                        <h4>{option.title}</h4>
                        <p>{option.description}</p>
                      </div>
                    </div>
                    <FaChevronRight className="account-option-arrow" />
                  </Card>
                ))}
              </div>
            </div>
          </div>
          <BottomNavigation />
          {/* End of Shell Container */}
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default AccountPage;